'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:synergiefrontends":true});}catch(e){}}();

import { Dictionaries } from 'shared/i18n/i18n-config';
import { getI18nUtils } from 'shared/i18n/i18n-utils';
import dynamic from 'next/dynamic';

// Import component dynamically with SSR disabled
// This is a workaround for the issue with SSR and Next.js
const IndexJobSearchForm = dynamic(() => import('shared/components/IndexJobSearchForm'), { ssr: false });

// sandyou.be/stylesheets/components/headerJobSearch.scss
export default function HeaderJobSearch({ dictionary }: { dictionary: Dictionaries }) {
  const { formatMessage } = getI18nUtils(dictionary);
  return (
    <section>
      <h1>{formatMessage({ id: 'headerJobSearchTitle' })}</h1>
      {/* SHARED COMPONENT:  sandyou.be/stylesheets/components/indexJobSearchForm.scss */}
      <IndexJobSearchForm dictionary={dictionary} />
    </section>
  );
}
